import { useQuery } from '@tanstack/react-query'
import { useCustomerContext } from '../../features/customer/CustomerProvider'
import { api } from '../../services/HttpService'

export const useTicketQueryKeyFactory = {
  // prettier-ignore
  getSingleTicket: (customerId?: number, ticketId?: string) => ['__getTicket', customerId, ticketId],
  // prettier-ignore
  getTicketComments: (customerId?: number, ticketId?: string) => ['__getTicket', customerId, ticketId, 'comments'],
  // prettier-ignore
  getTicketAttachments: (customerId?: number, ticketId?: string) => ['__getTicket', customerId, ticketId, 'attachments'],
}

export const useTicket = (ticketId?: string) => {
  const { customer } = useCustomerContext()

  const { data: ticket, isLoading: ticketIsLoading } = useQuery({
    queryKey: useTicketQueryKeyFactory.getSingleTicket(customer!.id, ticketId),
    enabled: !!customer?.id && !!ticketId && typeof ticketId === 'string',
    queryFn: async () => await api.tickets.getSingleTicket(customer!.id, ticketId!),
    staleTime: 5 * 60 * 1000,
  })

  const { data: comments, isLoading: commentsIsLoading } = useQuery({
    queryKey: useTicketQueryKeyFactory.getTicketComments(customer!.id, ticketId),
    enabled: !!customer?.id && !!ticketId && typeof ticketId === 'string',
    queryFn: async () => await api.tickets.getTicketComments(customer!.id, ticketId!),
    staleTime: 1 * 60 * 1000,
  })

  const { data: attachments, isLoading: attachmentsIsLoading } = useQuery({
    queryKey: useTicketQueryKeyFactory.getTicketAttachments(customer?.id, ticketId),
    enabled: !!customer?.id && !!ticketId && typeof ticketId === 'string',
    queryFn: async () => await api.tickets.getTicketAttachments(customer!.id, ticketId!),
  })

  return {
    ticket,
    ticketIsLoading,
    comments,
    commentsIsLoading,
    attachments,
    attachmentsIsLoading,
  }
}
